import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/components/layout/Layout';
import Wiki from '@/components/layout/Wiki';
import Home from '@/views/Home';
import BlackList from '@/views/BlackList';
import Calculator from '@/views/Calculator';
import Leasing from '@/views/Leasing';
import NodeDetail from '@/views/NodeDetail';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '/',
          component: Home,
        },
        {
          path: 'blacklist',
          component: BlackList,
        },
        {
          path: 'calculator',
          component: Calculator,
        },
        {
          path: 'wiki',
          component: Wiki,
          children: [
            {
              path: 'vsys-coin-leasing.html',
              component: Leasing,
            },
          ],
        },
        {
          path: 'detail/:id',
          component: NodeDetail,
        },
      ],
    },
  ],
});
